import { createFileRoute, Link } from '@tanstack/react-router'
import DashboardOverview from '@/pages/dashboard'

export const Route = createFileRoute('/')({ 
  component: DashboardOverview
})
